// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__3XomL","title":"Images45_title__1SiA6","images":"Images45_images__1AOZ1"};